import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Keyboard } from '@ionic-native/keyboard';
import { GlobalProvider } from '../../providers/global/global';
import { CKEditorComponent } from 'ngx-ckeditor';
/**
 * Generated class for the EditortextoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/*@IonicPage(
  {name:'page-editortexto'}
)*/
declare const CKEDITOR: any;
@Component({
  selector: 'page-editortexto',
  templateUrl: 'editortexto.html',
})


export class EditortextoPage {
  @ViewChild('editor')ckeditor: CKEditorComponent;
  public texto;
  //public Editor = ClassicEditor;
  constructor(public global: GlobalProvider,public keyboard: Keyboard,public viewCtrl: ViewController,public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditortextoPage');
  }
  ionViewDidEnter() {
    this.keyboard.show();
    this.texto = this.navParams.get("texto");
    
   
  }
  aceptar(){
  //  this.destroyEditor();
    this.keyboard.hide();
    let data = {texto: this.texto };
    this.viewCtrl.dismiss(data);
   /* this.navCtrl.push(HomePage, {
      coordenadaslat: this.coordenadaslat,
      coordenadaslong: this.coordenadaslong
    })*/
  }
  destroyEditor() {
    var name = this.ckeditor.instance.name;
    CKEDITOR.instances[name].destroy(true);
 }
 
  cancelar(){
    this.destroyEditor();
    this.keyboard.hide();
    this.viewCtrl.dismiss();
  
 
}
}



// WEBPACK FOOTER //
// ./src/pages/editortexto/editortexto.ts